import {mapActions, mapGetters} from 'vuex';
import SidebarMobile from '@/components/features/sidebar-mobile/index.vue'
import breadcrumbs from '@/components/breadcrumbs/index.vue'

const MainHeader = () => import('@/components/header/index.vue');
const MainFooter = () => import('@/components/features/footer/index.vue');

import comeInPopup from '@/components/popups/come-in-popup/index.vue';

export default {
	name        : 'home',
	data() {
		return {
			openReadMore        : false,
			openPopupAddCard    : false
		}
	},
	created() {
		if (!this.user && this.isAuthenticated) {
			this.fetchUser();
		}
		// TODO: tmp off before education-materials will be on
		// if (this.user && this.isAuthenticated) {
		//     this.fetchTariff();
		// }
	},
	components  : {
		MainHeader,
		MainFooter,
		SidebarMobile,
		breadcrumbs,
		'come-in-popup': comeInPopup,
	},
	computed    : {
		...mapGetters({
			isAuthenticated     : 'auth/isAuthenticated',
			user                : 'user/user',
			loadingUser         : 'user/loadingUser',
			userTariff          : 'user/userTariff',
			userTariffLoading   : 'user/userTariffLoading',
			cardsList           : "userPayments/cardsList"
		}),
		setSpecialStylesForWrap() {
			switch (this.$route.name) {
				case 'action-plans-detail': {
					return true
				}
				case 'news-view': {
					return true
				}
				case 'home-work': {
					return true
				}
				default: {
					return false
				}
			}
		}
	},
	mounted() {
		//console.log('home mounted');
		
		//this.loadData();
	},
	watch: {
		user            : {
			handler() {
				if(this.user != null){
					//this.loadData();
				}
				
				if (this.user && this.isAuthenticated) {
					// TODO: tmp off before education-materials will be on
					// this.fetchTariff();
					
					// TODO: don't know if it should be here
					// this.fetchUserHomeWork({dateFrom: '', dateTo: ''});
				}
			},
			deep: true
		},
		openPopupAddCard: {
			handler() {
				//console.log('openPopupAddCard2:');
				//console.log(this.openPopupAddCard);
			},
			deep: true
		}
	},
	methods     : {
		...mapActions({
			fetchUser           : `user/GET_USER_DATA`,
			fetchUserHomeWork   : `userHomework/GET_LIST`,
			fetchTariff         : `user/GET_USER_TARIFF`,
			fetchUserTariff     : "user/GET_USER_TARIFF",
			fetchCardsList      : "userPayments/GET_CARDS_LIST"
		}),
		async loadData(){
			console.log('home11');
			console.log('user22:');
			console.log(this.user);
			
			console.log('loadingUser:');
			console.log(this.loadingUser);
			
			if(this.user == null){
				console.log('user empty');
				
				return;
			}
			
			console.log('user ok');
			
			if(this.user.isNotRequiredCards === true){
				console.log('isNotRequiredCards');
				
				return;
			}
			
			await this.fetchCardsList();
			
			if(this.cardsList.length > 0){
				return;
			}
			
			await this.fetchUserTariff();
			
			if(this.userTariff.length > 0){
				for(let i = 0; i < this.userTariff.length; i++){
					if(
						this.userTariff[i].isConnected && 
						(
							this.userTariff[i].tariffId == 95 || 
							this.userTariff[i].tariffId == 94 ||
							this.userTariff[i].tariffId == 90 ||
							this.userTariff[i].tariffId == 88
						) && 
						this.userTariff[i].adminDisconnect == 0 && 
						this.userTariff[i].userDisconnect == 0
					){
						this.openPopupAddCard = true;
						break;
					}
				}
			}
			
			console.log('openPopupAddCard:');
			console.log(this.openPopupAddCard);
		}
	}
}
